export const version = "strings/5.0.5";
//# sourceMappingURL=_version.js.map